/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useEffect } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { datadogRum } from "@datadog/browser-rum";
import { Spin } from "antd";

import { apiClient } from "@alaffia-technology-solutions/client-sdk-react-query";

import { CapabilitiesProvider } from "../context/Capabilities.context";
import { UserContext } from "../context/User.context";
import { extractUser } from "./extractUser";

export const User = ({ id, children, loggedIn }) => {
  const { data } = apiClient.auditorUsers.getAuditorUser.useQuery(
    {
      id,
    },
    {
      enabled: loggedIn,
    },
  );

  useEffect(() => {
    if (
      !!data &&
      !!data.auditorUser &&
      !!data.auditorUser.id &&
      data.auditorUser.id.length > 0
    ) {
      const { auditorUser: au } = data;
      datadogRum.setUser({
        name: `${au.userType.toLowerCase()}@${au.id}`,
        id: au.id,
        userType: au.userType,
        readOnly: au.readOnly,
        claimIntakeEnabled: au.claimIntakeEnabled,
      });
    }
  }, [data]);

  return !loggedIn ? (
    // do nothing if not logged in
    <>{children}</>
  ) : !data ? (
    <Spin
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      style={{ width: "100vw", height: "100vh" }}
      delay={1000}
    />
  ) : (
    <UserContext value={extractUser({ auditorUser: data })}>
      <CapabilitiesProvider>{children}</CapabilitiesProvider>
    </UserContext>
  );
};
